<script setup lang="ts">
import { UseTimeAgo } from "@vueuse/components"

const props = defineProps({
  conversation: null
})

const { conversationIdAttr } = useGlobals()
const { onOpenExistingConversationIntent } = useAgent()

function onChatClick() {
  onOpenExistingConversationIntent(props.conversation.id)
}
</script>

<template>
  <div
    :[dataAttr(conversationIdAttr)]="conversation.id"
    class="chat-item"
    @click="onChatClick()"
  >
    <div v-if="conversation.title()" class="left">
      {{ conversation.title() }}
    </div>
    <div v-else class="left">
      <span class="untitled">
        Untitled Chat <use-time-ago
          v-slot="{ timeAgo }"
          :time="conversation.lastUpdated()"
        >({{ timeAgo }})</use-time-ago></span>
    </div>
    <div class="right">
      <!-- TODO: user avatars -->
    </div>
  </div>
</template>

<style lang="sass" scoped>
@import '~/assets/styles/generated/variables.sass'

.chat-item
  @apply flex items-center justify-between
  @apply -mx-1 -my-0.75 px-1 py-0.75 rounded-[#{$menu-br-item}]
  @apply cursor-pointer
  &:hover
    @apply bg-[#{$menu-bg-item-hover}]
  .left
    @apply t-panel-base text-ellipses-inline
    @apply min-w-0 w-full
    .untitled
      @apply text-[#{$global-t-secondary}] text-ellipses-inline
      @apply font-italic max-w-full
    .date
      @apply text-[#{$global-t-tertiary}]
  .right
    @apply flex-none
</style>
